// extracted by mini-css-extract-plugin
export default {"header":"header-module--header--_rwsu","title":"header-module--title--2VjU5","image":"header-module--image--3S570"};